import {gql} from 'apollo-angular';
import {baseResponseGraphqlField} from '../../../base.graphql';

export const instutionUsersField = `
id
adminProfile {
  id
  profileUniqueId
  userFirstName
  userLastName
  userEmail
  profilePhone
  profileTitle
  profilePhoto
  profileIsActive
  profileType
  profileIsDeactivated
}
adminRoles {
  id
  roleUniqueId
  roleName
  roleIsAdmin
  roleIsSystemDefault
  roleDescription
  rolePermissions {
    id
    permissionUniqueId
    permissionName
    permissionCode
  }
}
`;


export const instutionUsersgetField = `
id
userType
profile {
  id
  profileUniqueId
  userFirstName
  userLastName
  userEmail
  profilePhone
  profileTitle
  profilePhoto
  profileIsActive
  profileType
  profileIsDeactivated
}
role {
  id
  roleUniqueId
  roleName
  roleIsAdmin
  roleIsSystemDefault
  roleDescription
  rolePermissions {
    id
    permissionUniqueId
    permissionName
    permissionCode
  }
}
userDesignation {
        id
        designationUniqueId
        designationShortForm
        designationName
      }
`;



export const GET_ALL_INSTUTIONAL_USERS = gql`
query GetInstitutionUsers($filtering: UserFilteringInputObject){
  getInstitutionUsers(filtering:$filtering){
    ${baseResponseGraphqlField}
    data {
      ${instutionUsersgetField}
    }
  }
}
`;

export const CREATE_INSTUTION_USERS = gql`
mutation CreateInstitutionUsers($input: InstitutionAdminInputObject!) {
    createInstitutionUsers(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${instutionUsersgetField}
    }
  }
}
`;
export const UPDATE_INSTUTION_USERS = gql`
mutation updateInstitutionUsers($input: InstitutionAdminInputObject!) {
    updateInstitutionUsers(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${instutionUsersgetField}
    }
  }
}
`;

export const DELETE_INSTUTION_USERS = gql`
mutation deleteInstitutionUsers($profileUniqueId: String!) {
  deleteInstitutionUsers(profileUniqueId: $profileUniqueId) {
    ${baseResponseGraphqlField}
  }
}
`;

export const ACTIVATE_DEACTIVATE_USER_MUTATION = gql`
mutation ActivateDeactivateUserMutation($profileUniqueId: String!) {
  activateDeactivateUserMutation(profileUniqueId: $profileUniqueId) {
    ${baseResponseGraphqlField}
    data {
      id
      userType
      profile {
        id
        profileUniqueId
        userFirstName
        userLastName
        userEmail
        profilePhone
        profileTitle
        profilePhoto
        profileIsActive
        profileIsDeactivated
        profileType
      }
      role {
        id
        roleUniqueId
        roleName
        roleIsAdmin
        roleIsSystemDefault
        roleDescription
        rolePermissions {
          id
          permissionUniqueId
          permissionName
          permissionCode
        }
      }
      userDesignation {
        id
        designationUniqueId
        designationShortForm
        designationName
      }
    }
  }
}`
